// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3 23H21V1H3V23ZM14.0021 6.68761L11.504 8.75011V3.00011L16.5001 3.00011L16.5001 8.75011L14.0021 6.68761Z"}}]};

const CourseFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'course-filled',
    ref,
    icon: element,
  },
));

CourseFilledIcon.displayName = 'CourseFilledIcon';

export default CourseFilledIcon;
